import { render } from "./AppSwitcherMenu.vue?vue&type=template&id=4bb4c07d&ts=true"
import script from "./AppSwitcherMenu.vue?vue&type=script&lang=ts"
export * from "./AppSwitcherMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__